<template>
    <div class="rule-page">
        <h1>法律声明及服务条款</h1>

    	<h2>「导言」</h2>
        <p>欢迎使用探物科技软件及服务！在使用探物科技软件及各项服务前，请您务必仔细阅读并透彻理解以下声明。 若您对本声明存在任何疑问，可向客服咨询；若您不同意本声明或其中任何内容， 请您立即停止使用探物。当您注册成功后，无论是进入探物，还是在探物上发布任何内容， 均将被视为您（即「用户」）完全接受本声明以下全部条款</p>

    	<h2>使用规则</h2>
        <p>1）用户注册探物账号，制作、发布、传播信息内容的，应当使用真实身份信息及个人资料，不得以 虚假、冒用的居民身份信息进行注册；若用户的个人资料有任何变动，用户应及时更新。 </p>
        <p>2）用户可自行编辑注册信息中的账号名称、头像、简介等，但应遵守“七条底线”以及相关管理规定，不得含有违法和不良信息。 </p>
        <p>3）如用户违反前述约定，依据相关法律、法规及国家政策要求，探物有权随时采取不予注册、通知限期改正、注销登记用户账号、中止或终止用户对探物服务的使用等措施。如果用户冒用、关联机构或社会名人注册账号名称，探物有权注销用户该账号，并向互联网信息内容主管部门报告。</p>
        <p>4）用户在使用探物服务的过程中应文明发言，并依法尊重其它用户的人格权与身份权等人身权利，共同建立和谐、文明、礼貌的网络社交环境。 </p>
        <p>5）用户不得利用探物服务制作、上载、复制、发布、传播或者转载如下内容:</p>
        <ul>
            <li>不得违反中华人民共和国法律法规及相关国际条约或规则</li>
            <li>不得违反与网络服务、探物服务有关的网络协议、规定、程序及行业规则</li>
            <li>不得违反法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求</li>
            <li>不得上传、展示或传播任何不实虚假、冒充性的、骚扰性的、中伤性的、攻击性的、辱骂性的、恐吓性的、种族歧视性的、诽谤诋毁、泄露隐私、成人情色、恶意抄袭的或其他任何非法的信息资料</li>
            <li>不得以任何方式侵犯其他任何人依法享有的专利权、著作权、商标权等知识产权，或姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等人身权益，或其他任何合法权益</li>
            <li>不得从事其他任何影响探物平台正常运营、破坏探物平台经营模式或其他有害探物平台生态的行为</li>
            <li>不得为其他任何非法目的而使用探物服务</li>
        </ul>
        <p>6）用户不得对探物提供的试用产品进行如下行为:</p>
        <ul>
            <li>对产品进行拆解、改装、更换零件等损坏性行为</li>
            <li>对产品外观进行糟蹋、涂抹、剐蹭、张贴</li>
            <li>对产品进行出售、贩卖</li>
            <li>对产品进行永久性不可复原的损毁</li>
            <li>作为盗窃、凶杀、黑客攻击、病毒入侵等作案工具</li>
        </ul>
        <p>7）用户承诺不得以任何方式利用探物直接或间接从事违反中国法律、以及社会公德的行为。不得以任何方式损坏、损毁探物的试用产品。 </p>
        <p>如有违上述信息者，探物有权依据其合理判断不经通知直接采取一切必要措施以减轻或消除用户不当行为造成的影响，并将尽可能在处理之后对用户进行通知。上述必要措施包括但不限于更改、屏蔽或删除相关内容，警告违规账号，限制或禁止违规账号部分或全部功能，暂停、终止、注销用户使用探物服务的权利、扣取其押金等</p>

        <h2>隐私声明</h2>
        <p>1）我们收集哪些信息：</p>
        <p>在您创建或修改探物账号、使用探物产品和服务、联系客户支持或其他情况时，我们将会收集您直接向我们提供的信息，该信息包括但不限于：姓名、电话号码、电子邮箱、地址、银行卡信息、付款方式和您选择提供的其他信息</p>
        <p>通过您使用和访问探物app和探物服务时，我们会收集关于您以下信息</p>
        <p>同时也会收集其他与您相关的信息（包括但不限于设备信息、日志信息、位置信息、应用启动数，页面访问数，重点按钮点击数，设置项的配置属性等诸类类似的特征记录）。 </p>
        <p>2）我们可能将收集的信息用作下列用途</p>
        <ul>
            <li>向您提供服务</li>
            <li>在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性</li>
            <li>帮助我们设计新服务，改善我们现有服务</li>
            <li>帮助我们设计新服务，改善我们现有服务</li>
            <li>使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如内容喜好、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应</li>
            <li>评估我们服务中的内容数量、内容形式的效果，并加以改善</li>
            <li>软件认证或管理软件升级</li>
            <li>让您参与有关我们产品和服务的调查</li>
        </ul>
        <p>3）探物会在法律要求或符合探物的相关服务条款或本隐私声明载明的例外情况下透露您的个人信息</p>
        <ul>
            <li>满足法律或行政法规的明文规定，或者符合探物适用的法律程序</li>
            <li>符合探物相关服务条款、软件许可使用协议的约定</li>
            <li>保护探物的权利或财产</li>
            <li>在紧急情况下保护探物员工、探物产品及服务的用户或大众的个人安全</li>
        </ul>
        <p>探物不会未经您的允许将这些信息与第三方共享，本声明已经列出的上述情况除外。</p>
        <p>4）安全性说明</p>
        <ul>
            <li>探物科技将严格遵守有关法律法规和本隐私政策所载明的内容收集、使用您的信息。除非持有探物科技官方出具的授权文件，否则探物科技的具体工作人员不会直接向您索要个人信息。如遇此类情况，您可以直接与探物科技联系</li>
            <li>探物科技将尽合理的努力保障您的信息安全，使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题</li>
        </ul>

    	<h2>知识产权声明</h2>
        <p>1）探物科技是探物app的所有权及知识产权权利人。 </p>
        <p>2）探物科技是探物app及探物产品中所有信息内容的所有权及知识产权权利人。前述信息内容包括但 不限于标识、文字、图片、图形、图表、音频、视频、界面设计、版面框架、数据资料、程序代码等，除按照法律法规规定应由相关权利人享有权利的内容以外。 </p>
        <p>3）用户在探物上传或发表的内容，应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，探物有权根据实际情况删除相关的内容有权追究用户的法律责任，若给探物或任何第三方造成损失，用户应负责全额赔偿。</p>
        <p>4）内容进行任何保证性的、或连带性的承诺或担保，由此产生的任何纠纷、争议或损害，由用户与第三方自行解决，探物不承担任何责任。 </p>
        <p>5）探物有权但无义务对用户发布的内容进行审核，有权根据相关证据结合《侵权责任法》、《信息网络传播权保护条例》等法律法规对侵权信息进行处理。 </p>
        <p>6）用户发表并将其上传探物的任何内容，探物不限形式和载体地享有永久的、不可撤销的、免费的、非独家的使用权和转授权的权利，包括但不限于修改、复制、发行、展览、改编、汇编、出版、翻译、信息网络传播、广播、表演和再创作及著作权法等法律法规确定的其他权利。 </p>
        <p>7）恶意转载探物内容的，本平台保留将其诉诸法律的权利</p>

        <h2>免责声明</h2>
        <p>1）探物会致力于向您提供安全、稳定的优质服务。但是，探物不承诺本软件或本软件的人和内容、服务或功能无任何错误或中断，或者您对本软件的使用将产生特定结果。探物不保证网络服务一定能满足用户的需求，对网络服务的及时性、安全性、准确性也都不作保证。 </p>
        <p>2）探物提供的所有信息可不经通知而变更。 </p>
        <p>3）探物不作任何明示或默示保证，包括任何正确性、非侵权、适销性及适用性的保证。对于任何与您对探物或任何探物服务的使用有关的任何第三方的作为、不作为和行为，探物不承担责任。 </p>
        <p>4）用户在探物发表的内容仅表明其个人的立场和观点，并不代表探物的立场或观点。作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。探物不承担任何法律及连带责任。 </p>
        <p>5）由于用户将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄露，或其他非因探物原因导致的个人信息的泄露，探物不承担任何法律及连带责任。</p>
        <p>6）如果对探物或上述任何内容有任何不满意，您可以停止使用探物app或任何该等内容。 </p>
        <p>7）上述免责声明适用于因任何不履行、错误、疏忽、中断、删除、缺陷、操作或传输迟延、电脑病毒、通信线路故障、失窃或破坏或未经授权访问、篡改或使用（无论是违约、侵权、过失或任何其他诉因）而造成的任何损害、责任或伤害。</p>
        <p>8）探物科技保留在任何时候不经通知进行一下任何行为的权利:</p>
        <ul>
            <li>基于任何原因，修改、中止或终止探物网络相关服务运行或访问</li>
            <li>修改或变更探物网络相关服务其任何适用政策或条款</li>
            <li>在进行定期或非定期维护、错误纠正或其他变更所必须时，中断探物网络相关服务的运行</li>
        </ul>

        <h2>产品磨损判定及赔偿声明</h2>
        <p>1）磨损判定</p>
        <p class="h3">正常使用</p>
        <ul>
            <li>产品表面无肉眼可见的明显缺陷、凹陷、划痕、磨痕、开裂、掉漆</li>
            <li>无明显缺陷：与产品原样无恙</li>
            <li>无明显凹陷：最低处离水平处低于一毫米</li>
            <li>无明显划痕：长度低于0.5厘米</li>
            <li>无明显磨痕：磨痕面积小于0.1平方厘米</li>
            <li>无明显开裂：开裂长度低于0.5厘米</li>
            <li>无明显掉漆：面积小于0.25平方厘米</li>
        </ul>
        <p class="h3">一级</p>
        <ul>
            <li>存在有一处或多处用可通过触感或观感识别的凹陷、缺陷、磨痕、开裂、掉漆</li>
            <li>存在两处及两处以上的，低于0.5厘米的划痕</li>
            <li>存在一处或多处超过高于0.49厘米的划痕</li>
            <li>存在产品内部零部件脱落</li>
            <li>产品存在轻微变形，但不影响正常使用和观感</li>
            <li>可通过中国大陆的官方售后进行免费维修</li>
        </ul>
        <p class="h3">按照产品市场价的百分之十进行赔偿</p>
        <p class="h3">二级</p>
        <ul>
            <li>包含碎屏、裂屏、触摸失灵等需换屏操作</li>
            <li>大面积的磨损痕迹，超出产品面积十分之一</li>
            <li>产品存在严重变形，影响正常使用及观感</li>
            <li>可通过中国大陆的官方售后进行付费维修</li>
        </ul>
        <p class="h3">无中国大陆的官方售后产品一律按照产品市场价进行半额赔偿；有中国大陆官方付费维修则支付维修费用</p>
        <p class="h3">三级</p>
        <ul>
            <li>产品进入或接触粪池、污水渠、化工废液等生化性质污染场所</li>
            <li>损坏至无法进行产品职能</li>
            <li>损坏至官方保修及售后不予受理</li>
            <li>需更换两件及两件以上的零部件才能正常使用（官方免费维修除外）</li>
            <li>谎报、偷换、拆解产品等有违本《服务条款》所述的内容</li>
        </ul>
        <p class="h3">按照产品市场价进行全额赔偿</p>
        <p>2）超时赔偿标准和说明</p>
        <p>产品试用超时按照超出天数进行付费，不足一天则按一天收取。</p>
    </div>
</template>

<script>
    export default {
		data() {
            return {}
        },
    }
</script>

<style lang="scss">
   
</style>



// WEBPACK FOOTER //
// src/pages/content/children/disclaimer.vue